// ADDRESS SEARCH actions
import axios from 'axios';
import types from '../../types';

/* eslint-disable */
export default {
  [types.SET_PLACE_GOOGLE]: ({ commit }, payload) => {
    commit('SET_PLACE_GOOGLE', payload);
  },
  [types.GET_PLACE_API]: async ({ commit }, payload) => {
    try {
      let response = await axios.get(`/utilities/customer-address-search?query=${payload}`);
      commit('SET_PLACE_API', response.data.data);
      return response.data.data;
    } catch (e) {
      throw new Error(e);
    }
  },
};
